export const defaultSorting = { value: 'last-added', label: 'Last Added' };
